







































import axios from 'axios';
import i18n from 'vue-i18n';
import { get } from 'lodash';
import CoCard from '../../Molecules/co-card/CoCard.vue';
import CoThumbnail from '../../Molecules/co-thumbnail/CoThumbnail.vue';
import CoIcon from '../../Atoms/co-icon/CoIcon.vue';
import CoDate from '../../Molecules/co-date/CoDate.vue';
import CoSkeleton from '../../Atoms/co-skeleton/CoSkeleton.vue';

export default {
    components: { CoCard, CoThumbnail, CoIcon, CoDate, CoSkeleton },
    i18n: {
        messages: {
            en: {
                reacted: 'reacted to {subject}',
                'reaction-to-comment': 'reacted to the comment',
                commented: 'commented on {subject}',
                interested: 'is interested in {subject}',
                voted: 'voted on {subject}', // legacy
                other: 'interacted with {subject}',
                'mention-in-post': 'mentioned you in {subject}',
                'mention-in-comment': 'mentioned you in a comment on {subject}',
                'new-activity-on-post': 'new activity on {subject}',
                'new-event-participant': 'participanting in {subject}',
                'participation-revoked': 'cancelled participation in {subject}',
                'new-page-follower': 'started following {subject}',
                'new-owner-of-page': 'You are now co-owner of {subject}',
                'new-contributor-of-page': 'You are now a contributor of {subject}',
                'new-update-in-page-i-follow': 'created a post in {subject}',
                'new-event-organizer': 'You are now co-organizator of {subject}',
                emptyuserprofile: 'User with hidden profile',
                'content-that-might-interest-you': 'added something that might interest you',
                'new-update-in-event-i-follow': 'created a post in {subject}',
                'post-created': 'created the post {subject}',
                'admin-post-created': 'created the post {subject}',
                'admin-public-page-created': 'created the page {subject}',
                'admin-event-created': 'created the event {subject}',
                'admin-update-in-public-page-created': 'created a post in {subject}',
                'admin-market-item-created': 'created the market item {subject}',
                page_join_request: 'request to join {subject}',
            },
            de: {
                reacted: 'reagierte auf {subject}',
                'reaction-to-comment': 'reagierte auf deinen Kommentar',
                commented: 'kommentierte {subject}',
                interested: 'interessiert sich für {subject}',
                voted: 'hat über {subject} abgestimmt', // legacy
                other: 'hat mit {subject} interagiert',
                'mention-in-post': 'hat dich in {subject} erwähnt',
                'mention-in-comment': 'hat dich in einem Kommentar zu {subject} erwähnt',
                'new-activity-on-post': 'neue Aktivität bei {subject}',
                'new-event-participant': 'nimmt an {subject} teil',
                'participation-revoked': 'hat die Teilnahme an {subject} storniert',
                'new-page-follower': 'folgt {subject}',
                'new-owner-of-page': 'Du bist jetzt Miteigentümer:in von {subject}',
                'new-event-organizer': 'Du bist jetzt Organisator:in von {subject}',
                'new-contributor-of-page': 'Du bist jetzt Mitwirkende*r von {subject}',
                'new-update-in-page-i-follow': 'hat einen neuen Beitrag in {subject} erstellt',
                emptyuserprofile: 'Benutzer mit verstecktem Profil',
                'content-that-might-interest-you': 'hat etwas hinzugefügt, das dich interessieren könnte',
                'new-update-in-event-i-follow': 'hat einen neuen Beitrag in {subject} erstellt',
                'post-created': 'hat den Beitrag {subject} erstellt',
                'admin-post-created': 'hat den Beitrag {subject} erstellt',
                'admin-public-page-created': 'hat die Seite {subject} erstellt',
                'admin-event-created': 'hat das Event {subject} erstellt',
                'admin-update-in-public-page-created': 'hat einen neuen Beitrag in {subject} veröffentlicht',
                'admin-market-item-created': 'hat den Marktartikel {subject} erstellt',
                page_join_request: 'Anfrage zum Beitritt zur {subject}',
            },
        },
    },
    name: 'CoNotification',
    props: {
        item: {
            type: Object,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            author: null,
            object: null,
            subject: null,
            eventType: '',
            activityType: '',
            isNew: !(this.item && this.item.Seen),
            hideNotification: false,
        };
    },
    computed: {
        authorName() {
            return (
                get(this.author, 'Profile.Name', '') ||
                (get(this.item, 'Event.InitiatorID', null) ? this.$t('labels.usernotavailable') : '')
            );
        },
        isLoading: {
            get() {
                return this.loading;
            },
            set(value) {},
        },
    },
    created() {
        if (!this.item) return;

        this.isLoading = true;
        // Notifications now provide the initiator user directly, so prefer that payload over an extra lookup.
        this.author = this.getInitiatorUser();

        const promises = []; // create an array of promises

        this.eventType = this.item.Event.Type;

        // fetch content according to the subject type
        switch (this.item.Event.TargetType) {
            case 'post':
                promises.push(this.getPost(this.item.Event.TargetID));
                break;
            case 'event':
                promises.push(this.getEvent(this.item.Event.TargetID, this.eventType));
                break;
            case 'project':
            case 'page':
                promises.push(this.getPage(this.item.Event.TargetID, this.eventType));
                break;
            case 'projectupdate':
            case 'projectUpdate':
            case 'ProjectUpdate':
            case 'project-update':
            case 'page-update':
                promises.push(this.getPost(this.item.Event.TargetID));
                break;
            case 'market-item':
            case 'market_item':
            case 'job':
                promises.push(this.getMarket(this.item.Event.TargetID, this.eventType));
                break;
            case 'comment':
                // for comment notifications, we need to fetch the target post or event or page or update
                const commentTargetType = get(this.item, 'Event.Parameters.post_type', '');
                const commentTargetID = get(this.item, 'Event.Parameters.post_id', '');
                if (commentTargetType === 'post') {
                    promises.push(this.getPost(commentTargetID));
                } else if (commentTargetType === 'event') {
                    promises.push(this.getEvent(commentTargetID, this.eventType));
                } else if (commentTargetType === 'project' || commentTargetType === 'page') {
                    promises.push(this.getPage(commentTargetID, this.eventType));
                } else if (
                    commentTargetType === 'projectupdate' ||
                    commentTargetType === 'projectUpdate' ||
                    commentTargetType === 'ProjectUpdate' ||
                    commentTargetType === 'project-update' ||
                    commentTargetType === 'page-update' ||
                    commentTargetType === 'update'
                ) {
                    promises.push(this.getPost(commentTargetID));
                } else if (
                    commentTargetType === 'market-item' ||
                    commentTargetType === 'job' ||
                    commentTargetType === 'market_item'
                ) {
                    promises.push(this.getMarket(commentTargetID, this.eventType));
                }
            default:
                break;
        }

        switch (this.eventType) {
            case 'reaction-created':
            case 'reaction-removed':
            case 'reaction-to-post':
                this.activityType = 'reacted';
                break;
            case 'post-upvote-create':
            case 'post-downvote-create':
                this.activityType = 'voted';
                break;
            case 'comment-create':
                this.activityType = 'commented';
                break;
            case 'job-interest-create':
                this.activityType = 'interested';
                break;
            default:
                this.activityType = this.eventType;
                break;
        }

        // exit loading state when all content was fetched
        Promise.all(promises).finally(() => {
            this.isLoading = false;
        });
    },
    methods: {
        get, // lodash
        getInitiatorUser() {
            return get(this.item, 'InitiatorUser', null);
        },

        getPost(id) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'GET',
                    url: `/post/by-id/${id}`,
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                    .then((response) => {
                        const text = response.data.Text || response.data.Content || response.data.PollQuestion || '-';
                        this.subject = {
                            Title: this.getPostText(text),
                            Slug: `/post/${response.data.Slug}?commentid=${response.data.ID}`,
                        };
                    })
                    .catch((error) => {
                        this.hideNotification = true;
                        console.log(error);
                    })
                    .finally(() => {
                        resolve(true);
                    });
            });
        },

        getPage(id, eventtype) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'POST',
                    url: '/project/listbyids',
                    data: { IDS: [{ ID: id }] },
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                    .then((response) => {
                        if (!response.data.Projects || !response.data.Projects[0]) return;
                        this.subject = {
                            Title: response.data.Projects[0].Title,
                            Slug: `/page/${get(response, 'data.Projects[0].Slug')}`,
                        };

                        if (eventtype.includes('reaction') || eventtype.includes('comment')) {
                            this.subject.Slug = `/post/${get(response, 'data.Projects[0].Slug')}`;
                        }
                    })
                    .catch((error) => {
                        this.hideNotification = true;
                    })
                    .finally(() => {
                        resolve(true);
                    });
            });
        },

        getMarket(id, eventtype) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'GET',
                    url: `/job/by-id/${id}`,
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                    .then((response) => {
                        if (!response.data) return;
                        this.subject = {
                            Title: response.data.Title,
                            Slug: `/job/${response.data.Slug}`,
                        };

                        if (eventtype.includes('reaction') || eventtype.includes('comment')) {
                            this.subject.Slug = `/market-item-as-post/${response.data.Slug}`;
                        }
                    })
                    .catch((error) => {
                        this.hideNotification = true;
                    })
                    .finally(() => {
                        resolve(true);
                    });
            });
        },
        getEvent(id, eventtype) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'GET',
                    url: `/event/by-id/${id}`,
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                    .then((response) => {
                        if (!response.data) return;
                        this.subject = {
                            Title: response.data.Title,
                            Slug: `/event/${response.data.Slug}`,
                        };

                        if (eventtype.includes('reaction') || eventtype.includes('comment')) {
                            this.subject.Slug = `/post/${response.data.Slug}`;
                        }
                    })
                    .catch((error) => {
                        this.hideNotification = true;
                    })
                    .finally(() => {
                        resolve(true);
                    });
            });
        },

        getPostText(html) {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            return doc.body && doc.body.textContent ? `${doc.body.textContent.substring(0, 30)}...` : '';
        },

        markAsSeen(item) {
            const that = this;
            axios({
                method: 'POST',
                url: '/notification',
                data: {
                    NotificationID: item.ID,
                },
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.item.Seen = true;
                    this.isNew = false;
                })
                .catch((error) => {
                    console.log(error);
                    // todo show error
                })
                .finally(() => {
                    // update the notification count
                    if (that.$store) that.$store.dispatch('getGetNewNotifications');
                });
        },

        itemClick(event) {
            this.$emit('click', this.item);
            if (this.isNew) this.markAsSeen(this.item);
            if (this.subject && this.subject.Slug) this.$router.push(this.subject.Slug);
        },
    },
};
